import React from 'react';
import { components, OptionProps, GroupBase } from 'react-select';

interface ModeleOption {
  value: string | number;
  label: string;
}

const CustomOption = React.memo(
  (props: OptionProps<ModeleOption, true, GroupBase<ModeleOption>>) => {
    const { isSelected, label, innerProps } = props;

    return (
      <components.Option {...props}>
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            style={{ marginRight: 8, cursor: 'pointer' }}
          />
          <label style={{ cursor: 'pointer', margin: 0, flexGrow: 1 }}>
            {label}
          </label>
        </div>
      </components.Option>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.isSelected === nextProps.isSelected &&
      prevProps.isFocused === nextProps.isFocused
    );
  }
);

export default CustomOption;